import SimpleControl, {
  SimpleControlKind,
} from 'pages/revisions-module/template-editor/editors/template/toolbar/controls/SimpleControl';
import { useRichTextEditorContext } from '@mantine/tiptap';
import { IconArrowForwardUp } from '@tabler/icons-react';

/**
 * A button that allows the user to undo the last action.
 */
export default function Redo({ kind }: { kind: SimpleControlKind }) {
  const { editor } = useRichTextEditorContext();

  return (
    <SimpleControl
      kind={kind}
      icon={<IconArrowForwardUp />}
      label="Znova"
      shortcut="Ctrl + Y"
      onClick={() => editor?.chain().redo().focus().run()}
    />
  );
}
